<template>
  <hr-form-dialog
    ref="dialogRef"
    size="sm"
    :title="title"
    data-e2e="dialog-reorder-columns"
    @hide="onDialogHide"
    @submit="onSubmit"
  >
    <hr-sortable-list
      v-model="resultingOrder"
      item-key="value"
      long-press-body
    >
      <template #item="{ element }">
        <hr-sortable-item
          segmented
          flush
          :label="element.label"
          data-e2e="list-item-column"
        />
      </template>
    </hr-sortable-list>
    <template #actions>
      <hr-dismiss-btn
        data-e2e="button-cancel"
        :label="i18n.t('common.buttonCancel')"
        @click="hide"
      />
      <hr-confirm-btn
        type="submit"
        data-e2e="button-submit"
        :label="i18n.t('common.buttonSubmit')"
      />
    </template>
  </hr-form-dialog>
</template>

<script setup>
import { i18n } from 'boot/i18n';
import {
  HrConfirmBtn,
  HrDismissBtn,
  HrFormDialog,
  HrSortableItem,
  HrSortableList,
} from 'src/design-system';
import { ref } from 'vue';

defineOptions({ name: 'ReorderModal' });

const props = defineProps({
  title: {
    type: String,
    required: true,
  },

  options: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['hide', 'ok']);

const dialogRef = ref(null);
const resultingOrder = ref([...props.options]);

const show = () => {
  dialogRef.value.show();
};

const hide = () => {
  dialogRef.value?.hide();
};

const onDialogHide = () => {
  emit('hide');
};

const onSubmit = () => {
  emit('ok', resultingOrder.value.map((option) => option.value));
  hide();
};

// The dialog plugin calls these on the mounted component.
defineExpose({ show, hide });
</script>
